var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleSparkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.2L10.55 6.05C10.68 6.45 10.99 6.76 11.39 6.89L16.24 8.44L11.39 9.99C10.99 10.12 10.68 10.43 10.55 10.83L9 15.68L7.45 10.83C7.32 10.43 7.01 10.12 6.61 9.99L1.76 8.44L6.61 6.89C7.01 6.76 7.32 6.45 7.45 6.05L9 1.2Z",
    fill: "#010E15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleSparkIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_spark_icon.73684cc49f37487be73924f459f9813b.svg";
export { ForwardRef as ReactComponent };